module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-media', {
    attrs: {
      "height": "120",
      "src": _vm.src,
      "alt": ""
    }
  }, [_c('v-container', {
    staticClass: " playlist-overlay pa-0 ma-0"
  }, [_c('v-layout', {
    staticClass: " ma-0",
    attrs: {
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("play_arrow")]), _vm._v("\n                Play all\n            ")], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "audio-count"
  }, [_c('v-flex', [_vm._v("\n                Test test test\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2dd35f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaylistTeaserImage.vue
// module id = 344
// module chunks = 0